import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { BsModalRef } from "ngx-bootstrap/modal";
import { DataTransferService } from "src/app/services/data-transfer.service";
import { ApiService } from "../../../../services/api.service";
import { NgxCaptureService } from "ngx-capture";
import { tap } from "rxjs/operators";
import { MerchantService } from "src/app/services/merchant/merchant.service";
import { DatePipe } from "@angular/common";
import { TransactionStatusPipe } from "src/app/pipes/transaction-status.pipe";
import { NgxSpinnerService } from "ngx-spinner";

@Component({
  selector: "app-transaction-detail",
  templateUrl: "./transaction-detail.component.html",
  styleUrls: ["./transaction-detail.component.scss"],
})
export class TransactionDetailComponent implements OnInit {
  title: string;
  image: any;
  mapLocation: any;
  tranDetail: any;
  transactionId: any;
  mailText: any;
  @ViewChild("screen", { static: false }) screen: any;
  constructor(
    private api: ApiService,
    public modalRef: BsModalRef,
    public dataService: DataTransferService,
    private captureService: NgxCaptureService,
    private merchantService: MerchantService,
    private spinner: NgxSpinnerService,
    private datePipe: DatePipe,
    private TransactionStatusPipe: TransactionStatusPipe,
  ) {}

  async ngOnInit() {
    this.api
      .post(`payment/money/transaction-history/${this.transactionId}`, "", true)
      .then((response: any) => {
        this.tranDetail = response.data;
        if (this.tranDetail) {
          this.tranDetail.fees = this.tranDetail.fees
            ? Number(this.tranDetail.fees)
            : 0;
        }
        const latLng = (this.tranDetail.location || ("" as string)).split(",");
        if (latLng && latLng[0]) {
          this.mapLocation = { lat: Number(latLng[0]), lng: Number(latLng[1]) };
        }
      });
  }

  async ShareScreen() {
    var formattedBody = `User : ${this.title}  ${
      this.tranDetail.notes ? "\n Note: " + this.tranDetail.notes : ""
    } \n Amount : ${
      (this.tranDetail.transactionType === 1 ? "+" : "-") +
      this.tranDetail.currencySymbol +
      this.tranDetail.transferAmount
    } \n Date & Time : ${this.datePipe.transform(
      this.tranDetail.createdAt,
      "dd-MM-yyyy hh:mm a",
    )} \n Payment Method : ${
      this.tranDetail.stripeResponseJSON?.card
        ? "Credit Card****" + this.tranDetail.stripeResponseJSON?.card?.last4
        : "SmartPay wallet"
    } \n Fee: ${
      this.tranDetail.fees
        ? this.tranDetail.currencySymbol + this.tranDetail.fees
        : "Free"
    } \n Transaction ID: ${this.tranDetail.shortId} \n Reward Point: ${
      this.tranDetail.redeemedPoints || 0
    } \n Transaction status: ${this.TransactionStatusPipe.transform(
      this.tranDetail.status,
    )}`;
    this.mailText =
      "mailto:?" +
      "subject=Transaction receipt" +
      "&body=" +
      encodeURIComponent(formattedBody);
    window.location.href = this.mailText;
  }

  async DownloadScreen(fileName: any) {
    if (this.image && !this.image.includes("data:image/jpeg;base64")) {
      let data = { imageUrl: this.image };
      const respons: any = await this.merchantService.UrlToBase64(data);
      if (respons && respons.data) {
        this.image = "data:image/jpeg;base64," + respons.data;
        setTimeout(() => {
          this.captureService
            .getImage(this.screen.nativeElement, true)
            .pipe(
              tap((img) => {
                var link = document.createElement("a");
                link.href = img;
                link.download = fileName;
                document.body.appendChild(link);
                link.click();
              }),
            )
            .subscribe();
        }, 500);
      }
    } else {
      this.captureService
        .getImage(this.screen.nativeElement, true)
        .pipe(
          tap((img) => {
            const link = document.createElement("a");
            link.href = img;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            this.spinner.hide();
          }),
        )
        .subscribe();
    }
  }
}
